import { css } from '@emotion/react'

export const post = css({
  color: '#000000',
  fill: '#000000',
  textarea: {
    color: '#000000',
  },
})
